import type { MailboxInfo } from 'owa-client-types';
import { getAccountKeyForMailboxInfo } from 'owa-client-types';
import { getActivityFeedStore } from '../store/store';

export const isAccountInActivityFeedStore = (mailboxInfo: MailboxInfo): boolean => {
    const accountKey = getAccountKeyForMailboxInfo(mailboxInfo);
    return getActivityFeedStore().accountItems.has(accountKey);
};
